import React, { useState } from "react";
import * as styles from "./priceSection.module.css";
import { Box, Grid } from "@mui/material";
import Price from "../price/price";
import CTAButton from "../cta-button/ctaButton";

export default ({ node }) => {
  const { headText, subHeadText, priceItem, bottomImage } = node;

  let paymentImage = "";
  if (bottomImage && bottomImage.asset) {
    paymentImage = bottomImage.asset.url;
  }

  return (
    <Box className={styles.priceSectionBox}>
      <Box>
        <Box mb={2}>
          <Grid container>
            <Grid item md={12}>
              <h2 className={styles.peiceSectionHeadText}>{headText}</h2>
              <h2 className={styles.peiceSectionSubHeadText}>{subHeadText}</h2>
            </Grid>
          </Grid>
        </Box>
        <Box mb={2}>
          <Grid container spacing={2}>
            {priceItem.map((item) => {
              return (
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Price node={item} />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box sx={{ display: { xs: "block", sm: "none", md: "none" } }}>
          <CTAButton node={priceItem[0].orderButton} />
        </Box>
        {paymentImage ? (
          <Box>
            <Grid container justifyContent={"center"}>
              <Grid item md={6}>
                <img src={paymentImage} width={"100%"} />
              </Grid>
            </Grid>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};
